import { useTranslation } from "react-i18next";
import { formatDateTimeBs } from "@/lib/format";

interface Props {
  firstName: string;
  testName: string;
  expiresAt: string;
  onStart: () => void;
}

export function TestIntroScreen({ firstName, testName, expiresAt, onStart }: Props) {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-xl p-6">
      <h1 className="text-2xl font-semibold">{t("tests.public.welcome", { firstName })}</h1>
      <p className="mt-2 text-muted-foreground">{t("tests.public.testName", { name: testName })}</p>
      <p className="mt-1 text-xs text-muted-foreground">
        {t("tests.public.expiresAt", { time: formatDateTimeBs(expiresAt) })}
      </p>
      <p className="mt-4">{t("tests.public.instructions")}</p>
      <button
        type="button"
        onClick={onStart}
        className="mt-6 rounded bg-primary px-6 py-3 text-primary-foreground"
      >
        {t("tests.public.start")}
      </button>
    </div>
  );
}
